export interface StudentData {
  id: string
  studentId: string
  name: string
  initials: string
  age: number
  attendance: number
  performanceLevel: "Top Performer" | "Good" | "Average" | "Needs Support"
  avatarColor: string
}

export const ss2StudentsData: StudentData[] = [
  {
    id: "1",
    studentId: "#ESCP-001",
    name: "Chisom Okafor",
    initials: "CO",
    age: 14,
    attendance: 98,
    performanceLevel: "Top Performer",
    avatarColor: "bg-indigo-100 text-indigo-600",
  },
  {
    id: "2",
    studentId: "#ESCP-002",
    name: "Ade Emeka",
    initials: "AE",
    age: 15,
    attendance: 85,
    performanceLevel: "Average",
    avatarColor: "bg-orange-100 text-orange-600",
  },
  {
    id: "3",
    studentId: "#ESCP-003",
    name: "Fatima Bello",
    initials: "FB",
    age: 14,
    attendance: 70,
    performanceLevel: "Needs Support",
    avatarColor: "bg-purple-100 text-purple-600",
  },
  {
    id: "4",
    studentId: "#ESCP-004",
    name: "Daniel Yusuf",
    initials: "DY",
    age: 15,
    attendance: 92,
    performanceLevel: "Good",
    avatarColor: "bg-teal-100 text-teal-600",
  },
  {
    id: "5",
    studentId: "#ESCP-005",
    name: "Zainab Nuhu",
    initials: "ZN",
    age: 14,
    attendance: 88,
    performanceLevel: "Average",
    avatarColor: "bg-pink-100 text-pink-600",
  },
]

export interface SubjectData {
  id: string
  name: string
  teacher: string
  periodsPerWeek: number
  syllabusProgress: number
  category: "Core" | "Science" | "Arts" | "Elective"
  icon: string
  iconBg: string
  iconColor: string
  progressColor: string
}

export const ss2SubjectsData: SubjectData[] = [
  {
    id: "1",
    name: "Mathematics",
    teacher: "Mr. Johnson",
    periodsPerWeek: 4,
    syllabusProgress: 65,
    category: "Core",
    icon: "",
    iconBg: "bg-orange-100",
    iconColor: "text-orange-600",
    progressColor: "bg-orange-400",
  },
  {
    id: "2",
    name: "English Language",
    teacher: "Mrs. Davies",
    periodsPerWeek: 4,
    syllabusProgress: 80,
    category: "Core",
    icon: "",
    iconBg: "bg-blue-100",
    iconColor: "text-blue-600",
    progressColor: "bg-blue-400",
  },
  {
    id: "3",
    name: "Physics",
    teacher: "Mr. James Bond",
    periodsPerWeek: 3,
    syllabusProgress: 45,
    category: "Science",
    icon: "",
    iconBg: "bg-purple-100",
    iconColor: "text-purple-600",
    progressColor: "bg-purple-400",
  },
  {
    id: "4",
    name: "Biology",
    teacher: "Mrs. Adebayo",
    periodsPerWeek: 3,
    syllabusProgress: 55,
    category: "Science",
    icon: "",
    iconBg: "bg-pink-100",
    iconColor: "text-pink-600",
    progressColor: "bg-pink-400",
  },
  {
    id: "5",
    name: "Chemistry",
    teacher: "Mr. Okonkwo",
    periodsPerWeek: 3,
    syllabusProgress: 60,
    category: "Science",
    icon: "",
    iconBg: "bg-green-100",
    iconColor: "text-green-600",
    progressColor: "bg-green-400",
  },
  {
    id: "6",
    name: "Further Mathematics",
    teacher: "Mrs. Eze",
    periodsPerWeek: 3,
    syllabusProgress: 50,
    category: "Core",
    icon: "",
    iconBg: "bg-red-100",
    iconColor: "text-red-600",
    progressColor: "bg-red-400",
  },
  {
    id: "7",
    name: "Literature",
    teacher: "Mr. Adeyemi",
    periodsPerWeek: 2,
    syllabusProgress: 70,
    category: "Arts",
    icon: "",
    iconBg: "bg-yellow-100",
    iconColor: "text-yellow-600",
    progressColor: "bg-yellow-400",
  },
  {
    id: "8",
    name: "Government",
    teacher: "Mrs. Ibrahim",
    periodsPerWeek: 2,
    syllabusProgress: 75,
    category: "Arts",
    icon: "",
    iconBg: "bg-cyan-100",
    iconColor: "text-cyan-600",
    progressColor: "bg-cyan-400",
  },
]
